import React from 'react';
import {
    AccountText,
    ServicingDetails,
    LoanBalance,
    LoanActivityInfo,
    Vr,
    DateText,
    AmoutText,
    ServicingDetailsWrapper,
    ServiceWrapper,
    Hr
} from './ServicingLoanDetail.styled';
import { ServicingLoanDetailProps } from '../types';
import { currencyFormat } from '@utils/currency.format';
import { AmplifyLogs, UIConstants } from '@constants';
import Link from '@components/Link/Link';
import { PayOffWrapper, Title } from '@components/DetailsCard/DetailsCard.styled';
import { selectPayment } from '@store/selectors/payHistory.selector';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { PayDetails } from '@types';

const ServicingLoanDetail: React.FC<ServicingLoanDetailProps> = ({ account, accountDetails, component }) => {
    const { loanBalance, escrowBalance, interestRate, maturityDate, accountNumber } = account;
    const { accSummary, learnMore } = AmplifyLogs.paynowWidget;

    const payHistoryInfo: PayDetails = useSelector(selectPayment);

    return (
        <ServiceWrapper>
            <div>
                <Title>Current Loan Balance</Title>
                <ServicingDetailsWrapper>
                    <div id="servicingLoanDetails">
                        <ServicingDetails>
                            <LoanBalance>{currencyFormat(loanBalance)}</LoanBalance>
                            <AccountText>
                                {UIConstants.escrowBalance}: {currencyFormat(escrowBalance)}
                            </AccountText>
                            <AccountText>
                                {UIConstants.interestRate}: {interestRate}%
                            </AccountText>
                            <AccountText>
                                {UIConstants.maturing}: {maturityDate}
                            </AccountText>
                        </ServicingDetails>
                    </div>
                </ServicingDetailsWrapper>
            </div>
            {payHistoryInfo && (
                <>
                    <Vr />
                    <Hr />
                    <LoanActivityInfo>
                        <Title>Last Payment</Title>
                        <DateText>{`${moment(payHistoryInfo?.PaymentDate).format('MM/DD/YYYY')}`}</DateText>
                        <AmoutText>{`${currencyFormat(payHistoryInfo?.Total)} ${String(
                            payHistoryInfo?.Description
                        ).toLowerCase()} was applied.`}</AmoutText>
                        <Link onClick={accountDetails} eventAttributes={{ type: component, action: accSummary, loanNumber: accountNumber }}>
                            View Account Summary
                        </Link>
                        <PayOffWrapper>
                            <Title>Payoff Quote / Wire Transfer</Title>
                            <Link
                                eventAttributes={{ type: component, action: learnMore, loanNumber: accountNumber }}
                                href="https://www.freedommortgage.com/customer-center/articles/wire-payment-instructions"
                                target="_blank"
                            >
                                Learn More
                            </Link>
                        </PayOffWrapper>
                    </LoanActivityInfo>
                </>
            )}
        </ServiceWrapper>
    );
};

export default React.memo(ServicingLoanDetail);
